import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import Loader from "../../../../components/common/Loader";
import { Field, Form, Formik } from "formik";
import * as Yup from "yup";
import { updateOwner } from "../../../../features/apiCallAdmin";
import { FtextField } from "../../../../components/common/FtextField";

const EPS = ({ setShow, ispOwner }) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();

  //---> Local State
  const [isLoading, setIsLoading] = useState(false);
  const [passType, setPassType] = useState("password");

  // initial values for form
  let initialValues = {
    username: "",
    password: "",
    hashKey: "",
    merchantId: "",
    storeId: "",
    hasPG: true,
  };

  if (ispOwner) {
    const paymentGateway = ispOwner?.bpSettings?.paymentGateway;
    if (paymentGateway?.eps) {
      initialValues = {
        username: paymentGateway?.eps?.username,
        password: paymentGateway?.eps?.password,
        hashKey: paymentGateway?.eps?.hashKey,
        merchantId: paymentGateway?.eps?.merchantId,
        storeId: paymentGateway?.eps?.storeId,
      };
    }

    if (paymentGateway)
      initialValues = { ...initialValues, hasPG: ispOwner?.bpSettings?.hasPG };
  }

  const ispEPSValidator = Yup.object({
    username: Yup.string().required(t("fieldCannotBeBlank")),
    password: Yup.string().required(t("fieldCannotBeBlank")),
    hashKey: Yup.string().required(t("fieldCannotBeBlank")),
    merchantId: Yup.string().required(t("fieldCannotBeBlank")),
    storeId: Yup.string().required(t("fieldCannotBeBlank")),
    hasPG: Yup.boolean(),
  });

  const epsHandler = (values) => {
    let postBody = {
      ...ispOwner,
      bpSettings: {
        ...ispOwner.bpSettings,
        paymentGateway: {
          ...ispOwner.bpSettings.paymentGateway,
          gatewayType: "eps",
          eps: {
            username: values.username,
            password: values.password,
            hashKey: values.hashKey,
            merchantId: values.merchantId,
            storeId: values.storeId,
          },
        },
        hasPG: values.hasPG,
      },
    };

    updateOwner(ispOwner.id, postBody, setIsLoading, dispatch, setShow);
  };

  return (
    <Formik
      initialValues={initialValues}
      validationSchema={ispEPSValidator}
      onSubmit={(values) => {
        epsHandler(values);
      }}
      enableReinitialize
    >
      {() => (
        <Form>
          <div className="displayGrid3">
            <FtextField
              required
              type="text"
              label="User Name"
              name="username"
              validation={true}
            />
            <div>
              <FtextField
                required
                type={passType}
                label="Password"
                name="password"
                validation={true}
              />

              <div className="showPassword">
                <input
                  style={{ cursor: "pointer" }}
                  className="form-check-input shadow-none"
                  type="checkbox"
                  name="showPass"
                  id="showPass"
                  onChange={(e) =>
                    setPassType(e.target.checked ? "text" : "password")
                  }
                />
                <label
                  style={{ cursor: "pointer" }}
                  className="form-check-label text-mute"
                  htmlFor="showPass"
                >
                  &nbsp; Show Password
                </label>
              </div>
            </div>

            <FtextField
              required
              type="text"
              label="Hash Key"
              name="hashKey"
              validation={true}
            />

            <FtextField
              required
              type="text"
              label="Merchant ID"
              name="merchantId"
              validation={true}
            />

            <FtextField
              required
              type="text"
              label="Store ID"
              name="storeId"
              validation={true}
            />
          </div>

          <div className="displayGrid3">
            <div className="form-check mt-4">
              <Field
                className="form-check-input"
                type="checkbox"
                id="hasPG"
                name="hasPG"
              />
              <label className="form-check-label" for="hasPG">
                Has PG <span className="text-danger me-4">*</span>
              </label>
            </div>
          </div>

          <div className="displayGrid1 float-end mt-4">
            <button
              type="button"
              className="btn btn-secondary"
              disabled={isLoading}
              onClick={() => setShow(false)}
            >
              Cancel
            </button>

            <button
              type="submit"
              className="btn btn-success"
              disabled={isLoading}
            >
              {isLoading ? <Loader /> : "Submit"}
            </button>
          </div>
        </Form>
      )}
    </Formik>
  );
};

export default EPS;
